type ComponentType<T = any> = React.ComponentType<T>
type ComponentFunction = () => Promise<{ default: ComponentType }>

export const RetryChunkLazy: (
    component: ComponentFunction
) => Promise<{ default: any }> = (component: ComponentFunction) => {
    return new Promise((resolve, reject) => {
        //새로고침 되었는지
        const isRefreshed = JSON.parse(
            window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
        )

        //컴포넌트 IMPORT
        component()
            .then((data) => {
                //성공
                window.sessionStorage.setItem('retry-lazy-refreshed', 'false')
                resolve(data)
            })
            .catch((error) => {
                //실패
                if (!isRefreshed) {
                    window.sessionStorage.setItem(
                        'retry-lazy-refreshed',
                        'true'
                    )
                    return window.location.reload()
                }

                reject(error)
            })
    })
}
